import { VEHICLE_TYPES } from '@cargoflow/validators'
import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'
import { Fleet } from '@/features/fleet'

const ZodFleetSearch = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(10),
  license_plate: z.string().optional().catch(''),
  status: z
    .array(
      z.union([
        z.literal('active'),
        z.literal('idle'),
        z.literal('maintenance'),
        z.literal('retired'),
      ]),
    )
    .optional()
    .catch([]),
  vehicle_type: z.array(z.enum(VEHICLE_TYPES)).optional().catch([]),
  sort_by: z.enum(['license_plate', 'capacity_tons', 'created_at']).optional().catch(undefined),
  sort_dir: z.enum(['asc', 'desc']).optional().catch(undefined),
})

export const Route = createFileRoute('/_authenticated/fleet/')({
  validateSearch: ZodFleetSearch,
  component: Fleet,
})
